import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { GetStaffelsDocument, GetStaffelsQuery } from "__generated__/view/staffels/graphql/staffel.queries.generated";
import { ChildPropsFromPagination } from "types/commons";

export type StaffelSelectOption = ChildPropsFromPagination<GetStaffelsQuery, "staffels">;

// eslint-disable-next-line react-refresh/only-export-components
export enum StaffelSelectType {
  FeetStaffel = "FeetStaffel",
  GasolineStaffel = "GasolineStaffel",
  WaterLevelStaffel = "WaterLevelStaffel"
}

const StaffelSelect = <Multiple extends boolean = false,>({
	type,
	...rest
}: Omit<SelectProps<StaffelSelectOption, Multiple>, "fetchOptions" | "paginated" | "getOptionLabel"> & { type: StaffelSelectType }) => {
	const client = useApolloClient();

	const onFetchOptionsPaginated = async(_: string, page: number) => {
		try {
			const result = await client.query({
				query: GetStaffelsDocument,
				variables: {
					pagination: {
						page: page - 1,
						size: 10,
					},
					search: {
						type: type,
					},
				},
			});

			return {
				options: result.data.staffels.content,
				totalResults: result.data.staffels.totalElements || 0,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptionsPaginated}
			paginated
			getOptionLabel={option => option.description || ""} />
	);
};

export default StaffelSelect;
